import React, { lazy, Suspense } from 'react'
import { Routes, Route} from "react-router-dom";
const AboutUs = lazy(() => import('../Components/AboutUs'));
const Banner = lazy(() => import('../Components/Banner'));
const Books = lazy(() => import('../Components/EnglishPages/Books'));
const CriticalWorks = lazy(() => import('../Components/EnglishPages/CriticalWorks'));
const EditedWorks = lazy(() => import('../Components/EnglishPages/EditedWorks'));
const Life = lazy(() => import('../Components/EnglishPages/Life'));
const Photo = lazy(() => import('../Components/EnglishPages/Photo'));
const Poetry = lazy(() => import('../Components/EnglishPages/Poetry'));
const Portraits = lazy(() => import('../Components/EnglishPages/Portraits'));
const Programmes = lazy(() => import('../Components/EnglishPages/Programmes'));
const Translation = lazy(() => import('../Components/EnglishPages/Translation'));
const Video = lazy(() => import('../Components/EnglishPages/Video'));
const AdhyapakaGaveshakan = lazy(() => import('../Components/pages/AdhyapakaGaveshakan'));
const AniyaraShilpi = lazy(() => import('../Components/pages/AniyaraShilpi'));
const AyyappaPanikkareKurichullaGhrandhangal = lazy(() => import('../Components/pages/AyyappaPanikkareKurichullaGhrandhangal'));
const EditorSamaaharakarthavu = lazy(() => import('../Components/pages/EditorSamaaharakarthavu'));
const EnglishGadhyakaran = lazy(() => import('../Components/pages/EnglishGadhyakaran'));
const Gadhyakaran = lazy(() => import('../Components/pages/Gadhyakaran'));
const MalayalamKavi = lazy(() => import('../Components/pages/MalayalamKavi'));
const Niroopakan = lazy(() => import('../Components/pages/Niroopakan'));
const Vivarthakan = lazy(() => import('../Components/pages/Vivarthakan'));
const AnnouncementDetails = lazy(() => import('../Components/pages/AnnouncementDetails'));

const Routing = () => {
  return (
    <div>
        
        <Suspense fallback={<div className="p-8 text-center" role="status">Loading...</div>}>
        <Routes>
     <Route path="/" element={<Banner/>} />
     <Route path="/Kavi" element={<MalayalamKavi/>} />
     <Route path="/vivarthakan" element={<Vivarthakan/>} />
     <Route path="/gadhyakaran" element={<Gadhyakaran/>} />
     <Route path="/niroopakan" element={<Niroopakan/>} />
     <Route path="/editer-samaaharakarthavu" element={<EditorSamaaharakarthavu/>} />
     <Route path="/adhyapakan-gaveshakan" element={<AdhyapakaGaveshakan/>} />
     <Route path="/english-gadhyakaran" element={<EnglishGadhyakaran/>} />
     <Route path="/aniyara-shilpi" element={<AniyaraShilpi/>} />
     <Route path="/ayyappapanikare-kurichulla-grandhangal" element={<AyyappaPanikkareKurichullaGhrandhangal/>} />
     <Route path="/about-us" element={<AboutUs/>} />
     <Route path="/life" element={<Life/>} />
     <Route path="/poetrys" element={<Poetry/>} />
     <Route path="/translation" element={<Translation/>} />
     <Route path="/edited-works" element={<EditedWorks/>} />
     <Route path="/critical-works" element={<CriticalWorks/>} />
     <Route path="/programmes" element={<Programmes/>} />
     <Route path="/photo" element={<Photo/>} />
     <Route path="/video" element={<Video/>} />
     <Route path="/photo-portraits-and-with-luminaries" element={<Portraits/>} />
     <Route path="/photo-books" element={<Books/>} />
      <Route path="/announcement" element={<AnnouncementDetails/>} />
     
     
    </Routes>
    </Suspense>
    </div>
  )
}

export default Routing